import api from './api'

/**
 * 获取访问密钥列表
 * @param {Object} params 查询参数
 * @param {string} params.client_name 客户端名称（模糊查询，可选）
 * @param {boolean} params.is_active 激活状态（精确查询，可选）
 * @param {number} params.skip 跳过记录数（可选）
 * @param {number} params.limit 每页条数（可选）
 * @returns {Promise} 包含api_keys、total、page、size的对象
 */
export async function getApiKeys(params) {
  const res = await api.get('/api/v1/apikeys', { params })
  return res.data
}

/**
 * 创建访问密钥
 * @param {Object} keyData 密钥数据
 * @param {string} keyData.client_name 客户端名称
 * @param {string} keyData.expire_at 过期时间
 * @returns {Promise}
 */
export async function createApiKey(keyData) {
  const res = await api.post('/api/v1/apikeys/create', keyData)
  return res.data
}

/**
 * 更新访问密钥
 * @param {string|number} id 密钥ID
 * @param {Object} keyData 密钥数据
 * @param {string} keyData.client_name 客户端名称（可选）
 * @param {boolean} keyData.is_active 激活状态（可选）
 * @param {string} keyData.expire_at 过期时间（可选）
 * @returns {Promise}
 */
export async function updateApiKey(id, keyData) {
  const res = await api.put(`/api/v1/apikeys/update/${id}`, keyData)
  return res.data
}

/**
 * 启用密钥
 * @param {string|number} id 密钥ID
 * @returns {Promise}
 */
export async function activateApiKey(id) {
  const res = await api.post(`/api/v1/apikeys/${id}/activate`)
  return res.data
}

/**
 * 禁用密钥
 * @param {string|number} id 密钥ID
 * @returns {Promise}
 */
export async function deactivateApiKey(id) {
  const res = await api.post(`/api/v1/apikeys/${id}/deactivate`)
  return res.data
}

/**
 * 删除密钥
 * @param {string|number} id 密钥ID
 * @returns {Promise}
 */
export async function deleteApiKey(id) {
  const res = await api.delete(`/api/v1/apikeys/delete/${id}`)
  return res.data
}
